import ProductAdvantages from './ProductAdvantages';

export default ProductAdvantages;
